import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function setSelectedSubjectId({ commit }, subjectId) {
  commit(types.SET_SELECTED_SUBJECT_ID, subjectId);
}

export function fetchCatSubject({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/subjects?is_specialized=true`)
    .then(res => (
      dispatch('setCatSubjects', res.data)
    ));
}

export function setCatSubjects({ commit }, catSubjects) {
  commit(types.SET_CAT_SUBJECT, catSubjects);

  return Promise.resolve(catSubjects);
}

export function fetchCatDomain({ dispatch }, subjectsCount) {
  return http.get(`${MINERVA_API_URL}/cat-domains?per_page=${subjectsCount}`)
    .then(res => (
      dispatch('setCatDomains', res.data)
    ));
}

export function setCatDomains({ commit }, catDomains) {
  commit(types.SET_CAT_DOMAIN, catDomains);

  return Promise.resolve(catDomains);
}

function fetchAssignmentsStatus(status) {
  return http.get(`${MINERVA_API_URL}/assignments?status=${status}`)
    .then(res => res.data);
}

export function fetchActiveAssignments({ dispatch }, status) {
  return fetchAssignmentsStatus(status)
    .then(activeAssignments => (
      dispatch('setActiveAssignments', activeAssignments)
    ));
}

export function setActiveAssignments({ commit }, activeAssigments) {
  commit(types.SET_ACTIVE_ASSIGNMENT, activeAssigments);

  return Promise.resolve(activeAssigments);
}

export function creatCatCard({ dispatch }, { domainId, quizCount }) {
  return http.post(`${MINERVA_API_URL}/cats/`, {
    quiz_count: quizCount,
    domain_id: domainId,
  })
  .then(res => res.data);
}

export function fetchCatConfigs({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/cat-configs`)
    .then(res => (
      dispatch('setCatConfigs', res.data)
    ));
}

export function setCatConfigs({ commit }, catConfigs) {
  commit(types.SET_CAT_CONFIGS, catConfigs);

  return Promise.resolve(catConfigs);
}

function fetchUserProficiencyHistory(filters) {
  return http.get(`${MINERVA_API_URL}/users/cl-proficiency-history`, { params: filters })
    .then(res => res.data);
}

export function fetchFilterProficiencyHistory({ dispatch }, filters = {}) {
  return fetchUserProficiencyHistory(filters)
    .then(data => (
      dispatch('setFilterProficiencyHistory', {
        proficiencyHistory: data,
        subjectId: filters.subject_id || 0,
      })
    ));
}

export function setFilterProficiencyHistory({ commit }, proficiencyHistory) {
  commit(types.SET_FILTER_PROFICIENCY_HISTORY, proficiencyHistory);

  return Promise.resolve(proficiencyHistory);
}

function fetchUserProficiencyRank(filters) {
  return http.get(`${MINERVA_API_URL}/users/cl-proficiency-rank`, { params: filters })
    .then(res => res.data);
}

export function fetchFilterProficiencyRank({ dispatch }, filters = {}) {
  fetchUserProficiencyRank(filters)
    .then(data => (
      dispatch('setFilterProficiencyRank', {
        proficiencyRank: data,
        subjectId: filters.subject_id || 0,
      })
    ));
}

export function setFilterProficiencyRank({ commit }, proficiencyRank) {
  commit(types.SET_FILTER_PROFICIENCY_RANK, proficiencyRank);

  return Promise.resolve(proficiencyRank);
}

export function fetchChildProficiencyHistory({ dispatch }, filters) {
  fetchUserProficiencyHistory(filters)
    .then(data => (
      dispatch('setChildProficiencyHistory', {
        proficiencyHistory: data,
        subjectId: filters.subject_id || 0,
        childId: filters.child_id,
      })
    ));
}

export function setChildProficiencyHistory({ commit }, { childId, subjectId, proficiencyHistory }) {
  commit(types.SET_CHILD_PROFICIENCY_HISTORY, { childId, subjectId, proficiencyHistory });

  return Promise.resolve(proficiencyHistory);
}

export function fetchChildProficiencyRank({ dispatch }, filters) {
  return fetchUserProficiencyRank(filters)
    .then(data => (
      dispatch('setChildProficiencyRank', {
        proficiencyRank: data,
        subjectId: filters.subject_id || 0,
        childId: filters.child_id,
      })
    ));
}

export function setChildProficiencyRank({ commit }, { childId, subjectId, proficiencyRank }) {
  commit(types.SET_CHILD_PROFICIENCY_RANK, { childId, subjectId, proficiencyRank });

  return Promise.resolve(proficiencyRank);
}

export function setSelectedChild({ commit }, selectedChild) {
  commit(types.SET_SELECTED_CHILD, selectedChild);
}

export function setSelectedLectureSubjectId({ commit }, selectedLectureSubjectId) {
  commit(types.SET_SELECTED_LECTURE_SUBJECT_ID, selectedLectureSubjectId);
}

function fetchVideoLectures(filters) {
  return http.get(`${MINERVA_API_URL}/video-lectures`, { params: filters })
    .then(res => res.data);
}

export function fetchFilterVideoLectures({ dispatch }, filters = {}) {
  return fetchVideoLectures(filters)
    .then(data => (
      dispatch('setFilterVideoLectures', {
        videoLectures: data,
        subjectId: filters.subject_id || 0,
      })
    ));
}

export function setFilterVideoLectures({ commit }, { videoLectures, subjectId }) {
  commit(types.SET_VIDEO_LECTURES, { videoLectures, subjectId });

  return Promise.resolve(videoLectures);
}

function fetchCardLectures(filters) {
  return http.get(`${MINERVA_API_URL}/card-lectures`, { params: filters })
    .then(res => res.data);
}

export function fetchFilterCardLectures({ dispatch }, filters = {}) {
  return fetchCardLectures(filters)
    .then(data => (
      dispatch('setFilterCardLectures', {
        cardLectures: data,
        subjectId: filters.subject_id || 0,
      })
    ));
}

export function setFilterCardLectures({ commit }, { cardLectures, subjectId }) {
  commit(types.SET_CARD_LECTURES, { cardLectures, subjectId });

  return Promise.resolve(cardLectures);
}

export function fetchSubjects({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/subjects`)
    .then(res => (
      dispatch('setSubjects', res.data)
    ));
}

export function setSubjects({ commit }, subjects) {
  commit(types.SET_SUBJECTS, subjects);

  return Promise.resolve(subjects);
}

function fetchRecommendVideoLectures(params) {
  return http.get(`${MINERVA_API_URL}/users/me/recommendations/video-lectures`, { params })
    .then(res => res.data);
}

export function fetchMainRecommendVideoLectures({ dispatch }, filters) {
  return fetchRecommendVideoLectures(filters)
    .then(data => (
      dispatch('setRecommendVideoLectures', data)
    ));
}

export function setRecommendVideoLectures({ commit }, videoLectures) {
  commit(types.SET_RECOMMEND_VIDEO_LECTURES, videoLectures);

  return Promise.resolve(videoLectures);
}

function fetchRecommendCardLectures(params) {
  return http.get(`${MINERVA_API_URL}/users/me/recommendations/card-lectures`, { params })
    .then(res => res.data);
}

export function fetchMainRecommendCardLectures({ dispatch }, filters) {
  return fetchRecommendCardLectures(filters)
    .then(data => (
      dispatch('setRecommendCardLectures', data)
    ));
}

export function setRecommendCardLectures({ commit }, cardLectures) {
  commit(types.SET_RECOMMEND_CARD_LECTURES, cardLectures);

  return Promise.resolve(cardLectures);
}

export function fetchFilterRecommendVideoLectures({ dispatch }, filters) {
  return fetchRecommendVideoLectures(filters)
    .then(data => (
      dispatch('setFilterVideoLectures', {
        videoLectures: data,
        subjectId: filters.subject_id || 0,
      })
    ));
}


export function fetchFilterRecommendCardLectures({ dispatch }, filters) {
  return fetchRecommendCardLectures(filters)
    .then(data => (
      dispatch('setFilterCardLectures', {
        cardLectures: data,
        subjectId: filters.subject_id || 0,
      })
    ));
}

export function setBusy({ commit }, busy) {
  commit(types.SET_BUSY, busy);
}



// WEBPACK FOOTER //
// ./src/app/cat-main/store/actions.js